module.exports = __webpack_public_path__ + "img/world-user-01.17a2b552.jpg";